/* global window document */
import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';

import css from './context-modal.scss';

import { CONTEXT_MODAL_POSITION } from './context-modal-constants';

class ContextModal extends Component {
    static propTypes = {
        className: PropTypes.string,
        show: PropTypes.bool,
        onClickOutsideHandler: PropTypes.func,
        children: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.bool,
            PropTypes.string
        ]),
        position: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.setContextModalRef = this.setContextModalRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        const containsModalEvent =
            this.contextModalRef &&
            !this.contextModalRef.contains(event.target);

        if (containsModalEvent) {
            this.props.onClickOutsideHandler();
        }
    };

    setContextModalRef = (node) => {
        this.contextModalRef = node;
    };

    render() {
        if (this.props.show) {
            return (
                <div
                    className={`${css['context-modal']} ${this.props.className}`}
                    ref={this.setContextModalRef}
                >
                    <div
                        className={`${css['modal-container']} ${
                            css[this.props.position]
                        }`}
                    >
                        {this.props.children}
                    </div>
                </div>
            );
        }

        return null;
    }
}

ContextModal.defaultProps = {
    position: CONTEXT_MODAL_POSITION.MODAL_UP
};

export default styleable(css)(ContextModal);



// WEBPACK FOOTER //
// ./components/context-modal/context-modal.js